<template>
  <div class="c-table">
    <el-table
      ref="tableRef"
      class="common-el-table-styles"
      stripe
      border
      style="width: 100%"
      :cell-class-name="cellClassName"
      :data="$attrs.data"
      :height="tableHeight"
      v-on="$listeners"
    >
      <el-table-column type="selection" width="90"></el-table-column>
      <el-table-column
        v-for="col in columns"
        :key="col.key"
        :prop="col.key"
        :label="col.title"
        :width="col.width"
        :show-overflow-tooltip="col.overflow"
        :sortable="col.sortable"
      >
        <template slot-scope="{ row }">
          <template v-if="col.key === 'addr'">
            <el-image
              v-if="row.type === IMAGE_TYPES.GROUP_IMAGE"
              v-popover="{ url: row.overviewAddr, type: 'image', height: 280 }"
              style="height: 76px; cursor: pointer"
              :src="row.overviewAddr"
            ></el-image>

            <template
              v-else-if="
                [
                  IMAGE_TYPES.VIDEO,
                  IMAGE_TYPES.META,
                  IMAGE_TYPES.AI_REMIX,
                  IMAGE_TYPES.REMIX_AUDIT_DENY,
                  IMAGE_TYPES.REMIX_AUDIT_PASS,
                  IMAGE_TYPES.REMIX_AUDIT_PRE,
                  IMAGE_TYPES.SHOT
                ].includes(row.type)
              "
            >
              <el-image
                v-popover="{ url: row.field1, type: 'video', height: row.width > row.height ? 280 : 420 }"
                style="height: 76px; cursor: pointer"
                :src="row.addr"
              ></el-image>
            </template>

            <el-image
              v-else
              v-popover="{ url: row.addr, type: 'image', height: 280 }"
              style="height: 76px; cursor: pointer"
              :src="row.addr"
            ></el-image>
          </template>

          <template v-else-if="col.key === 'excludeMediaNames'">
            <div v-if="row.excludeMediaNames">
              <p style="line-height: 16px" v-for="item in row.excludeMediaNames.split(',')" :key="item">{{ item }}</p>
            </div>
          </template>

          <template v-else-if="col.key === 'videoDesc'">
            <slot name="videoDesc" :row="row"></slot>
          </template>

          <template v-else-if="col.key === 'videoClips'">
            <slot name="videoClips" :row="row"></slot>
          </template>

          <template v-else>
            <span v-if="col.formatter">{{ col.formatter({ row }) }}</span>
            <span v-else>{{ row[col.key] }}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { IMAGE_TYPES } from '@/views/material/uploading/consts.js'
// Props
// eslint-disable-next-line
const props = defineProps({
  columns: {
    type: Array
  },

  tableHeight: {
    type: String,
    default: '330'
  }
})

const cellClassName = ({ row, column }) => {
  if (['videoDesc'].includes(column.property)) {
    return 'video-desc-cell'
  }

  if (['videoClips'].includes(column.property)) {
    return 'video-clips-cell'
  }
  if (['addr'].includes(column.property)) {
    return 'addr-cell'
  }
}

// Template refs
const tableRef = ref(null)

const toggleRowSelection = (row, check) => {
  tableRef.value.toggleRowSelection(row, check)
}

// Expose methods for parent component access
// eslint-disable-next-line
defineExpose({
  toggleRowSelection
})
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;

  ::v-deep .video-desc-cell {
    .cell {
      white-space: pre-wrap !important;
    }
  }

  ::v-deep .video-clips-cell {
    .cell {
      white-space: nowrap !important;
    }
  }

  ::v-deep .addr-cell {
    .cell {
      > span {
        display: block;
        text-align: center;
      }

      .video-material-ref {
        position: relative;
        .el-icon-video-play {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          font-size: 24px;
          line-height: 76px;
          z-index: 10;
          color: #fff;
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
